export default [
    {
        path: "reports",
        name: "rrhh-reports",
        redirect: { name: "rrhh-reports-monthly" },
        component: () => import("@/views/monitoring/views/reports/Reports.vue"),
        meta: {
            section: 12,
            pageTitle: "Reports",
            breadcrumb: [
                {
                    text: "Monthly",
                },
            ],
            tabs: [
                {
                    title: "Monthly",
                    name: "rrhh-reports-monthly",
                },
                {
                    title: "Details",
                    name: "rrhh-reports-details",
                },
                {
                    title: "Year",
                    name: "rrhh-reports-year",
                },
            ],
        },
        children: [
            {
                path: "Monthly",
                name: "rrhh-reports-monthly",
                component: () =>
                    import(
              /* webpackChunkName: "RrhhReportsMonthly" */ "@/views/monitoring/views/reports/components/ReportsTab.vue"
                    ),
                meta: {
                    section: 12,
                    tab: 1,
                    pageTitle: "Reports",
                    breadcrumb: [
                        {
                            text: "Monthly",
                            active: true
                        },
                    ],
                },
            },
            {
                path: "details",
                name: "rrhh-reports-details",
                component: () =>
                    import(
              /* webpackChunkName: "RrhhReportsDetails" */ "@/views/monitoring/views/reports/components/ReportsTab.vue"
                    ),
                meta: {
                    section: 12,
                    tab: 2,
                    pageTitle: "Reports",
                    breadcrumb: [
                        {
                            text: "Details",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "year",
                name: "rrhh-reports-year",
                component: () =>
                    import(
              /* webpackChunkName: "RrhhReportsDetails" */ "@/views/monitoring/views/reports/components/year/YearReportsTab.vue"
                    ),
                meta: {
                    section: 12,
                    tab: 3,
                    pageTitle: "Reports",
                    breadcrumb: [
                        {
                            text: "Year",
                            active: true,
                        },
                    ],
                },
            },
        ],
    },
];
